import { createPeloton } from '@engage/api-v2';
import { engageApi } from '../lib/singletons';
import { unwrap } from '../lib/unwrap';
import { toFetcher } from './toFetcher';
export var toPelotonFetchers = function toPelotonFetchers() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  return {
    CreatePeloton: toFetcher(function (params) {
      return "CreatePeloton".concat(params.rideId);
    }, function (_ref) {
      var rideId = _ref.rideId;
      return unwrap(function () {
        return createPeloton(api, {
          rideId: rideId
        });
      });
    }, {
      revalidateIfStale: true
    })
  };
};